import { combineReducers } from 'redux';
import { CALENDAR_SET_DATE } from 'actions/calendar/constants';
import moment from 'moment';
import createReducer from 'utils/createReducer';

// FIXME unserialisable type
const startDate = createReducer(moment(), {
  [CALENDAR_SET_DATE]: (draft, { payload }) => moment(payload.startDate),
});

// FIXME unserialisable type
const endDate = createReducer(moment(), {
  [CALENDAR_SET_DATE]: (draft, { payload }) => moment(payload.endDate),
});

export default combineReducers({
  startDate,
  endDate,
});
